export const IMAGE_HOST = "https://cdn.bvote.vn";

export const MAX_PRICE = 50000000;

export const COMBO_LIST = [
  {
    id: "1",
    name: "combo1",
    price: 2000,
    point: 1,
  },
  {
    id: "2",
    name: "combo2",
    price: 20000,
    point: 10,
  },
  {
    id: "3",
    name: "combo3",
    price: 50000,
    point: 25,
  },
  {
    id: "4",
    name: "combo4",
    price: 100000,
    point: 50,
  },
];

// export const COMBO_LIST = [
//   {
//     id: "1",
//     combo: "50 điểm",
//     priceDisplay: "20.000 đ",
//     price: 20000,
//     point: 50,
//   },
//   {
//     id: "2",
//     combo: "150 điểm",
//     priceDisplay: "50.000 đ",
//     price: 50000,
//     point: 150,
//   },
//   {
//     id: "3",
//     combo: "450 điểm",
//     priceDisplay: "100.000 đ",
//     price: 100000,
//     point: 450,
//   },
//   {
//     id: "4",
//     combo: "2500 điểm",
//     priceDisplay: "200.000 đ",
//     price: 200000,
//     point: 2500,
//   },
//   {
//     id: "5",
//     combo: "5000 điểm",
//     priceDisplay: "300.000 đ",
//     price: 300000,
//     point: 5000,
//   },
// ];
